import type { TextSizes } from '@nautilusbio/nb-design-system/helpers';

const textSizeOrder: TextSizes[] = ['xs3', 'xs2', 'xs', 'sm', 'md', 'lg', 'xl', 'xl2', 'xl3', 'xl4', 'xl5', 'xl6'];

/**
 * Returns the TextSizes value one step smaller than the given size.
 * Returns the input unchanged if already at the smallest size.
 */
export function downSize(size: TextSizes): TextSizes {
  const idx = textSizeOrder.indexOf(size);
  return idx > 0 ? textSizeOrder[idx - 1] : size;
}
